import { render, staticRenderFns } from "./white-papers-archives.vue?vue&type=template&id=2193a1dc"
import script from "./white-papers-archives.vue?vue&type=script&lang=js"
export * from "./white-papers-archives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports